import { RENTAL_PORTAL_VIEWING_STATUSES } from '../../../../../../constants/rentalPortal'
import { EntityStatus } from '../../../../../Entity'
import {
  getListingViewingTimeRangeLabel,
  RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN,
  RentalPortalViewingDateCell,
} from '../../../../../RentalPortalViewing'
import {
  TableCellBase,
  TableEmptyCell,
  TableTextCell,
} from '../../../../../Table'
import { LISTING_VIEWING_COLUMN_NAME } from '../RentalPortalListingProfileViewings.constants'
import { getListingViewingApplicantLabel } from '../RentalPortalListingProfileViewings.utils'

export function renderListingProfileViewingsCell({
  item,
  locale,
  name,
  timezone,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case LISTING_VIEWING_COLUMN_NAME.DateTime:
      return value ? (
        <RentalPortalViewingDateCell
          {...restProps}
          isFreeSlot={item.status === RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN}
          locale={locale}
          start={value}
          timeLabel={getListingViewingTimeRangeLabel({
            end: item.end,
            locale,
            start: item.start,
            timezone,
          })}
          timezone={timezone}
        />
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case LISTING_VIEWING_COLUMN_NAME.Applicant:
      return (
        <TableTextCell
          {...restProps}
          value={getListingViewingApplicantLabel(item)}
        />
      )

    case LISTING_VIEWING_COLUMN_NAME.Status:
      return RENTAL_PORTAL_VIEWING_STATUSES[value] ? (
        <TableCellBase {...restProps}>
          <EntityStatus id={value} statuses={RENTAL_PORTAL_VIEWING_STATUSES} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    default:
      return <TableTextCell {...restProps} value={value} />
  }
}
